module.exports = __webpack_public_path__ + "static/fmarketing__banner--big-6c6f0cb65cf90c8a6e692ebe5bf8d45d.jpg";